import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'DESPESA_LANCAMENTO_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro,
				
			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('despesaLancamentoForm', {
			...registro,
	
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'DESPESA_LANCAMENTO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(despesaLancamento = false) {

	return (dispatch, getState) => {

		dispatch({
			type: 'DESPESA_LANCAMENTO_LISTADO',
			payload: { data: [] }
		});

		let dataInicial = DateFormat.formatarDataTelaParaParametro(getState().despesaLancamento.filtro.dataInicial);
		let dataFinal = DateFormat.formatarDataTelaParaParametro(getState().despesaLancamento.filtro.dataFinal);


		dataInicial = dataInicial && dataInicial == 'Invalid DateTime' ? null : dataInicial;
		dataFinal = dataFinal && dataFinal == 'Invalid DateTime' ? null : dataFinal;
		


		if (despesaLancamento) {
			axios.get(`${consts.API_URL}/despesaLancamento?
				data_inicial=${dataInicial}
				&data_final=${dataFinal}
				`)

			.then(resp => {
	            dispatch({
					type: 'DESPESA_LANCAMENTO_LISTADO',
			        payload: resp
				});
	        }).catch(ex => {

			});
		} else {
			axios.get(`${consts.API_URL}/despesaLancamento?
				data_inicial=${dataInicial}
				&data_final=${dataFinal}
				`)
			.then(resp => {
	            dispatch({
					type: 'DESPESA_LANCAMENTO_LISTADO',
			        payload: resp
				});
	        }).catch(ex => {

			});
		}
    };
}
export function getListaDespesa() {
    const request = axios.get(`${consts.API_URL}/financeiroTipo/listarSelect`);
    return {
        type: 'DESPESA_LANCAMENTO_DESPESA_LISTADO',
        payload: request
    };
}
export function getListaEvento() {
    const request = axios.get(`${consts.API_URL}/evento/listarSelect`);
    return {
        type: 'DESPESA_LANCAMENTO_EVENTO_LISTADO',
        payload: request
    };
}
export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/despesaLancamento`, {
				...registro,
				datahora_despesa: registro.datahora_despesa ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_despesa) : null,
				id_usuario_alteracao: getState().auth.usuario.id,
				id_usuario_inclusao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/despesaLancamento`, {
				...registro,
				datahora_despesa: registro.datahora_despesa ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_despesa) : null,
				id_usuario_alteracao: getState().auth.usuario.id,
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/despesaLancamento?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function setFiltro(filtro) {
    console.log(filtro);
    return {
        type: 'DESPESA_LANCAMENTO_FILTRO',
        payload: filtro
    };
}

export function buscarReserva(pesquisa) {
    const request = axios.get(`${consts.API_URL}/cliente/buscarReserva?pesquisa=${pesquisa}`);
    return {
        type: 'RESERVA_BUSCAR_CLIENTE_SELECT_LISTADO',
        payload: request
    };
}